import React, { useEffect, useMemo, useState } from "react";
import {
  FormControl,
  Box,
  Button,
  Chip,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  allCategories,
  allGames,
  deleteGameDetail,
} from "../../redux/Slices/extSlice";
import Datatable from "../mui-datatable/Datatable";
import { toast } from "react-toastify";
import EditImg from "../../assets/icons/edit_icon.png";
import DeleteImg from "../../assets/icons/delete_icon.png";
import {useNavigate } from "react-router-dom";
import Modal from "@mui/material/Modal";
import UpdateGame from "./UpdateGame";
const AllGames = () => {
  const auth = useSelector((state) => state.user.isAuthenticated);
  const dispatch = useDispatch();
  const allext = useSelector((state) => state.ext.table?.data);
  const { categories } = useSelector((state) => state.ext);
  const { user } = useSelector((state) => state.user);

  const [selectedcategory, setselectedcategory] = useState("all");
  const [updateId, setUpdateId] = useState("");
  const [GamesrowData, setGamesrowData] = useState([]);
  const [page, pagechange] = useState(0);
  const [rowsPerPage, rowsPerPageChange] = useState(5);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    // console.log("useffect runned");
    const fetchData = async () => {
      try {
        // if (auth) {
        // let data = { limit };
        const data = { cat: selectedcategory };
        dispatch(allGames(data))
          .then((data) => {
            // console.log(data, "data in algames dispatch");
            if (data.payload?.code === 200) {
              toast.success("Data loaded successfully!", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
              });
            } else {
              toast.error("Something went wrong", {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
              });
            }
          })
          .catch((err) => {
            console.log(err, "err in all ext");
            toast.error("Something went wrong", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          });
        dispatch(allCategories())
          .then((data) => {
            if (data.payload?.code === 200) {
              // toast.success("Data loaded successfully!", {
              //   position: toast.POSITION.TOP_CENTER,
              //   autoClose: 3000,
              // });
            } else {
              // toast.error("Something went wrong", {
              //   position: toast.POSITION.TOP_CENTER,
              //   autoClose: 3000,
              // });
            }
          })
          .catch((err) => {
            console.log(err, "err in all ext");
            toast.error("Something went wrong", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          });
        // }
      } catch (error) {
        console.error("Error fetching extensions:", error);
      }
    };

    fetchData();
  }, [auth, dispatch, selectedcategory]);
  const handleOpen = (rowData) => {
    // console.log(rowData, "rowData");
    setOpen(true);
    setUpdateId(rowData?.[0]);
    // console.log(allext, "allext");
    let selectedRow = allext.filter((data) => data._id === rowData?.[0]);

    setGamesrowData(selectedRow);
  };
  const handleDelete = async (id) => {
    console.log("runned");
    const formData = {
      id,
    };

    try {
      if (user?.role === "admin" || user?.user?.role === "admin") {
        dispatch(deleteGameDetail(formData)).then((data) => {
          // console.log(data, "data");
          if (data?.payload?.code === 200) {
            const data = { cat: selectedcategory };
            dispatch(allGames(data));
            toast.success("Deleted Successfully!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          } else {
            toast.error("Something went wrong!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
      } else {
        toast.error("You are not authorize for this action", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
        });
      }
    } catch (error) {
      toast.error("Something went wrong!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 3000,
      });
    }
  };

  const handleClose = () => setOpen(false);
  const renderActionCell = (value, tableMeta) => {
  return (
    <div style={{ display: "inline-flex", gap: "8px" }}>
      <IconButton onClick={() => handleOpen(tableMeta.rowData)}>
        <Box
          component="img"
          src={EditImg}
          alt="edit"
          sx={{ width: 28, height: 28 }}
        />
      </IconButton>

      <IconButton onClick={() => handleDelete(tableMeta.rowData[0])}>
        <Box
          component="img"
          src={DeleteImg}
          alt="delete"
          sx={{ width: 28, height: 28 }}
        />
      </IconButton>
    </div>
  );
};


  const categoryMap = useMemo(() => {
    const map = new Map();
    if (categories?.data && Array.isArray(categories.data)) {
      categories.data.forEach((cat) => {
        // Store both string and ObjectId versions for flexibility
        const idStr = String(cat._id);
        map.set(idStr, cat.cat_name);
        // Also store the original _id in case it's already a string
        if (cat._id) {
          map.set(cat._id, cat.cat_name);
        }
      });
    }
    return map;
  }, [categories]);

 const resolveLogo = (game) => {
  const extract = (val) => {
    // Return empty string for falsy values
    if (!val) return "";

    // If it's already a string, return it directly
    if (typeof val === "string") return val;

    // If it's an array, recursively extract from the first element
    if (Array.isArray(val)) {
      return val.length > 0 ? extract(val[0]) : "";
    }

    // If it's an object, try to find the URL/path in various property names
    if (typeof val === "object" && val !== null) {
      return (
        val.url ||
        val.URL ||
        val.link ||
        val.Link ||
        val.Location ||
        val.location ||
        val.path ||
        val.Path ||
        val.file ||
        val.File ||
        val.filename ||
        val.filename ||
        ""
      );
    }

    return "";
  };

  // strict priority: logo_img → icon_img → featured_img → logo
  // Check if logo_img exists first, then extract
  if (game?.logo_img) {
    const extracted = extract(game.logo_img);
    if (extracted) return extracted;
  }
  
  // Check icon_img as fallback (used in backend)
  if (game?.icon_img) {
    const extracted = extract(game.icon_img);
    if (extracted) return extracted;
  }
  
  // Check featured_img
  if (game?.featured_img) {
    const extracted = extract(game.featured_img);
    if (extracted) return extracted;
  }
  
  // Check logo
  if (game?.logo) {
    const extracted = extract(game.logo);
    if (extracted) return extracted;
  }

  return "";
};

  const tableRows = useMemo(() => {
    return (allext || []).map((game) => {
      const categoryNames =
        game?.cat_arr && Array.isArray(game.cat_arr)
          ? game.cat_arr
              .map((id) => {
                // Try to find the category name by ID (both as-is and as string)
                const idStr = String(id);
                return categoryMap.get(id) || categoryMap.get(idStr) || null;
              })
              .filter((name) => name !== null && name !== undefined)
          : [];
      return {
        ...game,
        id: game?._id,
        game_name: game?.game_name || game?.title || "Untitled",
        game_link: game?.game_link || game?.game_url || "",
        category_name: categoryNames.length > 0 ? categoryNames.join(", ") : "Uncategorized",
        categories: categoryNames,
        game_file: game?.game_file || "",
        game_logo: resolveLogo(game),
        cat_arr_raw: game?.cat_arr || [],
      };
    });
  }, [allext, categoryMap]);

  const baseColumns = [
    {
      name: "id",
      label: "ID",
      options: { display: false },
    },
    {
      name: "title",
      label: "Game Name",
      options: {

        customBodyRender: (value) => {
          
          // if (!value) return "—";

      // Convert to string and replace hyphens with spaces
      // const formatted = String(value).replace(/-/g, " ");

      return (
        <Typography fontWeight={600} color="text.primary">
          {value}
        </Typography>
      );
        },
      },
    },
    {
      name: "game_link",
      label: "Game URL",
      options: {
        customBodyRender: (value) =>
          value ? (
            <a
              href={value}
              target="_blank"
              rel="noreferrer"
              style={{ color: "#000000", textDecoration: "none", fontWeight: 600 }}
            >
              {value}
            </a>
          ) : (
            <Typography color="text.secondary">Not set</Typography>
          ),
      },
    },
    {
      name: "game_logo",
      label: "Game Logo",
      options: {
        customBodyRender: (value) =>
          value ? (
            <Box
              component="img"
              src={"https://www.punogames.com/assets"+value}
              alt={"C:/Users/intel/Pictures/amant/testing/assets"+value}
              sx={{ height: 100, width: 150, objectFit: "contain" }}
            />
            
          ) : (
            <Typography color="text.secondary">No logo</Typography>
          ),
      },
    },
    {
      name: "category_name",
      label: "Category Name",
      options: {
        setCellHeaderProps: () => ({
      style: { fontWeight: "bold" },
    }),
        customBodyRender: (value) =>
          value ? (
            <Typography color="text.primary">{value}</Typography>
          ) : (
            <Typography color="text.secondary">Uncategorized</Typography>
          ),
      },
    },
    
    // {
    //   name: "game_file",
    //   label: "Game File",
    //   options: {
    //     customBodyRender: (value) =>
    //       value ? (
    //         <Button
    //           component="a"
    //           href={value}
    //           target="_blank"
    //           rel="noreferrer"
    //           size="small"
    //           variant="text"
    //         >
    //           {value.split("/").pop()}
    //         </Button>
    //       ) : (
    //         <Typography color="text.secondary">Not uploaded</Typography>
    //       ),
    //   },
    // },
  ];

  const dynamicColumns =
    allext && allext.length > 0
      ? Object.keys(allext[0])
          .filter(
            (key) =>
              ![
                "cat_arr",
                "_id",
                "game_name",
                "game_link",
                "game_file",
                "logo_img",
                "featured_img",
                "game_logo",
              ].includes(key)
          )
          .map((key) => {
            if (key === "meta_title" || key === "meta_description" || key === "title") {
              return {
                name: key,
                label: key.replace(/_/g, " "),
                options: {
                  display: false,
                  customBodyRender: (value) => (
                    <Typography
                      sx={{
                        maxWidth: 220,
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                      title={value}
                    >
                      {value}
                    </Typography>
                  ),
                },
              };
            }
            if (key === "description") {
              return {
                name: key,
                label: "description",
                options: {
                  display: false,
                  customBodyRender: (value) => (
                    <Typography
                      sx={{
                        maxWidth: 260,
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                      }}
                      title={value}
                    >
                      {value}
                    </Typography>
                  ),
                },
              };
            }
            return {
              name: key,
              label: key.replace(/_/g, " "),
              options: {
                display: false,
                filter: true,
                sort: true,
              },
            };
          })
      : [];

  const columns = [
    ...baseColumns,
    {
      name: "cat_arr_raw",
      label: "Categories (IDs)",
      options: {
        display: false,
        customBodyRender: (value) =>
          Array.isArray(value) && value.length > 0 ? value.join(", ") : "N/A",
      },
    },
    {
      name: "categories",
      label: "Category (badges)",
      options: {
        display: false,
        customBodyRender: (value) =>
          value && value.length > 0 ? (
            <Stack direction="row" spacing={0.5} flexWrap="wrap">
              {value.map((cat) => (
                <Chip
                  key={cat}
                  label={cat}
                  size="small"
                  sx={{ mb: 0.5 }}
                  color="primary"
                  variant="outlined"
                />
              ))}
            </Stack>
          ) : (
            <Typography color="text.secondary">Uncategorized</Typography>
          )
          
      },
    },
    ...dynamicColumns,
    {
  name: "actions",
  label: "Action",
  options: {
    customBodyRender: (value, tableMeta) =>
      renderActionCell(value, tableMeta),
      filter: false,
      sort: false,
      setCellProps: () => ({
        style: {
          textAlign: "center",       // SAFE, does not break dynamic height
          verticalAlign: "middle",   // keeps it vertically centered
        },
      }),
      setCellHeaderProps: () => ({
        style: {
          textAlign: "center",
        },
      }),
  },
}


  ];
  const options = {
    selectableRows: "none",
    filter: true,
    print: false,
    download: false,
    pagination: true,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 15],
    page: page,
    onChangePage: (newPage) => {
      // console.log(page, "page in onchangepage");
      pagechange(newPage);
      // if (newPage === Math.ceil(allext.length / rowsPerPage) - 1) {
      //   // setLimit((prev) => prev + 15);
      // }

      // pagechange({ ...page, current: page, prev: page - 1 });
    },
    onChangeRowsPerPage: (value) => {
      rowsPerPageChange(value);
      // if (value > allext.length) {
      //   setLimit((prev) => prev + 15);
      // }
      // pagechange(0);
    },
    setRowProps: (row, dataIndex, rowIndex) => {
      // Check if the rowIndex is even or odd using the modulo operator (%)
      const isEven = rowIndex % 2 === 0;
      return {
        style: {
          backgroundColor: isEven ? "#EFF0FF" : "#ffffff", // Light gray for even rows, white for odd
        },
      };
    },
    responsive: "standard",
    elevation: 0,
     setTableHeadCellProps: () => ({
    style: {
      fontWeight: "bold",
      fontSize: "1rem"
    }
  }),

  };

  const setCategory = async (value) => {
    setselectedcategory(value);
    try {
      let data = {
        cat: value,
      };
      dispatch(allGames(data))
        .then((data) => {
          if (data.payload?.code === 200) {
            toast.success("Data loaded successfully!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          } else {
            toast.error("Something went wrong", { 
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        })
        .catch((err) => {
          console.log(err, "err in all ext");
          toast.error("Something went wrong", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        });
    } catch (error) {
      console.log(error, "error in setCategory");
    }
  };
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        width: "98%",
        minHeight: "100vh",
        backgroundColor: "#F6F7FF",
        pt: 10,
        pb: 4,
      }}
    >
      <Box sx={{ width: "82%", ml: "auto" }}>
        <Paper
          elevation={0}
          sx={{
            p: 3,
            mb: 2,
            borderRadius: 3,
            backgroundColor: "#ffffff",
            border: "1px solid #e5e8fb",
            color: "#1f2b6c",
          }}
        >
          <Stack
            direction={{ xs: "column", md: "row" }}
            alignItems={{ xs: "flex-start", md: "center" }}
            justifyContent="space-between"
            spacing={2}
          >
            <Box>
              <Typography variant="h5" fontWeight={700}>
                Games Overview
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Quick view of the games library with the essentials only.
              </Typography>
            </Box>
            <Stack direction="row" spacing={2} alignItems="center">
              <FormControl sx={{ minWidth: 150 }} size="small" variant="outlined">
                <InputLabel id="demo-select-small-label">Categories</InputLabel>
                <Select
                  labelId="demo-select-small-label"
                  id="demo-select-small"
                  value={selectedcategory}
                  label="Categories"
                  onChange={(e) => setCategory(e.target.value)}
                >
                  <MenuItem value="all">All</MenuItem>
                  {categories?.data &&
                    categories?.data.length > 0 &&
                    categories?.data.map((category) => (
                      <MenuItem key={category._id} value={category._id}>
                        {category.cat_name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <Button
                variant="contained"
                sx={{
                  fontWeight: 600,
                  backgroundColor: "#4a5bff",
                  "&:hover": { backgroundColor: "#3c4de6" },
                  textTransform: "none",
                }}
                onClick={() => navigate("/addgame")}
              >
                Add Game
              </Button>
            </Stack>
          </Stack>
        </Paper>

        <Paper
          elevation={0}
          sx={{
            width: "100%",
            overflow: "hidden",
            borderRadius: 3,
            p: 2,
            backgroundColor: "#fff",
            boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
          }}
        >
          <Datatable
            title="Games"
            data={tableRows}
            columns={columns}
            options={options}
          />
        </Paper>
      </Box>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <UpdateGame
          categories={categories?.data}
          handleClose={handleClose}
          updateId={updateId}
          testimonialtoupdate={GamesrowData}
        ></UpdateGame>
      </Modal>
    </Box>
  );
};

export default AllGames;
